import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SupplierForm from '../../../components/Suppliers/SupplierForm';
import Toast from '../../../components/Common/Toast';
import { supplierService } from '../../../services/supplierService';

const EditVentasClient = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await supplierService.getSupplier(id);
        if (!cancelled && res.success && res.data) {
          setClient(res.data);
        }
      } catch {
        if (!cancelled) {
          setToast({ isOpen: true, message: 'No se pudo cargar el cliente', type: 'error' });
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [id]);

  if (loading) {
    return <div className="p-6 text-gray-500">Cargando cliente…</div>;
  }

  if (!client) {
    return <div className="p-6 text-red-600">Cliente no encontrado</div>;
  }

  return (
    <div className="p-6">
      <div className="max-w-5xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Editar Cliente</h1>
          <p className="text-gray-600 mt-1">{client.name}</p>
        </div>
        <SupplierForm
          isPageMode
          supplier={client}
          forceClientOnly
          onSuccess={() => {
            setToast({ isOpen: true, message: 'Cliente actualizado', type: 'success' });
            setTimeout(() => navigate('/ventas/clients'), 1500);
          }}
          onError={(error) => {
            setToast({
              isOpen: true,
              message: error.response?.data?.message || 'Error al actualizar cliente',
              type: 'error',
            });
          }}
        />
      </div>
      <Toast
        isOpen={toast.isOpen}
        message={toast.message}
        type={toast.type}
        onClose={() => setToast((t) => ({ ...t, isOpen: false }))}
      />
    </div>
  );
};

export default EditVentasClient;
